import { StoreState } from '@/redux/types';
import { getCore } from './getCore';

export function getFeatures(state: StoreState) {
  return getCore(state).features;
}
